import { FC } from 'react';
import Link from 'next/link';
import { HEADER_BANNER_LFROM } from '@/helpers/variables';
import { hideImgOnError } from '@/helpers/helpers';
import styles from './HeaderBanner.module.scss';

const HeaderBanner: FC = () => {
  return (
    <div className={styles.litresHeaderBanner}>
      <Link prefetch={false} className={styles.litresHeaderBanner__link} target="_blank" href={`https://www.litres.ru/collections/a-sinistra/?lfrom=${HEADER_BANNER_LFROM}`}>
        <img onError={hideImgOnError} width="1920" height="60" className={styles.litresHeaderBanner__img} src="/banners/sinistra-1920x60.jpg" alt="banner" />
        <img onError={hideImgOnError} width="450" height="100" className={`${styles.litresHeaderBanner__img} ${styles.litresHeaderBanner__img_mobile}`} src="/banners/sinistra-450x100.jpg" alt="banner" />
      </Link>
    </div>
  );
};

export default HeaderBanner;
